import { SyncInfo } from 'modules/app/types';
import { RootState } from '../../../../config/store/rootReducer';
import { Country } from '../../../../types/countries';
import { createSelector } from 'reselect';

export const makeGetCountriesSelector =
  () =>
  (state: RootState): Country[] =>
    state.globalInfo.countries;

const getSyncInfo = (state: RootState): SyncInfo | null => state.syncInfo;
export const makeGetSyncInfo = () => createSelector(getSyncInfo, (syncInfo: SyncInfo | null) => syncInfo);
